var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",style:({ height: _vm.videoHeightStyle })},[_c('div',{staticClass:"w-100 flex-grow-1 embedded-video",attrs:{"id":_vm.videoIdSanitized}})])
}
var staticRenderFns = []

export { render, staticRenderFns }